module.exports = __webpack_public_path__ + "assets/img/oneForOne_1.467bc49f.png";